import React from 'react';
import './UniversityPage.css';

const UniversityPage11 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Milan (Statale)</h1>
                    <h2>Medicine and Surgery Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>The <strong>Medicine and Surgery</strong> program at the University of Milan (Statale) is a highly respected, six-year degree taught in English, designed to train future doctors with a strong scientific foundation and extensive clinical experience. The program integrates theoretical learning with hands-on training in some of Italy's best hospitals, equipping students with the skills needed for a successful medical career worldwide. The medical faculty is located in the eastern part of Milan.</p>
                    <a href="https://www.unimi.it/en/education/single-cycle-master/international-medical-school-ims"> International Medical School (IMS) | Università degli Studi di Milano Statale</a><br></br>
                    <a href="https://www.unimi.it/en/education/faculties-and-schools/medicine/studying-medicine-and-surgery"> Studying Medicine and Surgery | Università degli Studi di Milano Statale</a>
                </section>

                <section className="ranking">
                    <h2>International Rankings</h2>
                    <p>The University of Milan (Statale) consistently ranks among the top universities in Italy and Europe:</p>
                    <ul>
                        <li><strong>QS World University Rankings:</strong> Ranked in the top <strong>200-250 universities worldwide</strong>.</li>
                        <li><strong>Medical School Ranking:</strong> Among the top <strong>100-150 for Medicine globally</strong>.</li>
                        <li><strong>Times Higher Education:</strong> Consistently recognized for its research and academic excellence.</li>
                    </ul>
                </section>

                <section className="seats-available">
                    <h2>EU and Non-EU Seats</h2>
                    <p>The Medicine and Surgery program at the University of Milan (Statale) has a limited number of seats available each year, divided between <strong>EU and non-EU students</strong>. The seat allocation typically follows this structure:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>EU Students</th>
                                    <th>Non-EU Students</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>~55 seats</td>
                                    <td>~15 seats</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="imat-scores">
                    <h2>IMAT Exam and Admission Scores</h2>
                    <p>Admission to IMS is based on the <strong>IMAT (International Medical Admissions Test)</strong> score. Below are the recent minimum IMAT scores required for admission:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Non-EU Minimum Score</th>
                                    <th>EU First / Last Round Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2020</td>
                                    <td>47.8</td>
                                    <td>First: 57.8 / Last: 45</td>
                                </tr>
                                <tr>
                                    <td>2021</td>
                                    <td>51.5</td>
                                    <td>First: 51.5 / Last: 43.3</td>
                                </tr>
                                <tr>
                                    <td>2022</td>
                                    <td>51.8</td>
                                    <td>First: 52 / Last: 44.3</td>
                                </tr>
                                <tr>
                                    <td>2023</td>
                                    <td>60.2</td>
                                    <td>First: 47.6 / Last: 46.6</td>
                                </tr>
                                <tr>
                                    <td>2024</td>
                                    <td>75.7</td>
                                    <td>First: 69.2 / Last: 67.8</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="course-structure">
                    <h2>Curriculum Breakdown</h2>
                    <p>The degree course consists of <strong>360 credits overall</strong>, spread over a six-year program, of which at least <strong>60 must be acquired in training</strong> aimed at the acquisition of specific professional abilities.</p>

                    <h3>First Year</h3>
                    <h4>First Semester</h4>
                    <ul>
                        <li>Cells, Molecules and Genes (Biology, Molecular Biology)</li>
                        <li>Fundamentals of Basic Sciences (Chemistry and Introductory Biochemistry, Medical Physics)</li>
                        <li>Histology</li>
                    </ul>
                    <h4>Second Semester</h4>
                    <ul>
                        <li>Anatomy</li>
                        <li>Biochemistry</li>
                        <li>Fundamentals of Biomedical Imaging (Medical Physics, Radiology and Radiotherapy)</li>
                    </ul>

                    <h3>Second Year</h3>
                    <h4>First Semester</h4>
                    <ul>
                        <li>Functions 1 (Biochemistry, Physiology)</li>
                        <li>Genetics (Biology, Genetics)</li>
                        <li>Microbiology</li>
                    </ul>
                    <h4>Second Semester</h4>
                    <ul>
                        <li>Functions 2 (Anatomy, Physiology)</li>
                        <li>Mechanisms of Diseases</li>
                    </ul>

                    <h3>Third Year</h3>
                    <h4>Optional Courses (Clerkship)</h4>
                    <ul>
                        <li>Fundamentals of Clinical Medicine 1 (Cardiovascular Diseases, Nephrology, Respiratory Diseases)</li>
                        <li>Fundamentals of Clinical Medicine 2 (Blood Diseases, Internal Medicine, Rheumatology)</li>
                        <li>Fundamentals of Clinical Medicine 3 (Dermatology, Endocrinology, Gastroenterology, Physical Training Sciences and Methodology)</li>
                    </ul>
                    <h4>First Semester (Compulsory)</h4>
                    <ul>
                        <li>Fundamentals of Clinical Medicine 1 (Cardiovascular Diseases, General Surgery, Internal Medicine, Nephrology, Respiratory Diseases)</li>
                        <li>Fundamentals of Clinical Medicine 1 (Clerkship) (Cardiovascular Diseases, General Surgery, Internal Medicine, Nephrology, Respiratory Diseases)</li>
                        <li>Fundamentals of Clinical Medicine 2 (Blood Diseases, Internal Medicine, Rheumatology)</li>
                        <li>Fundamentals of Clinical Medicine 2 (Clerkship) (Rheumatology)</li>
                        <li>Translational Medicine and Biotechnologies 1 (Clinical Biochemistry, Informatics, Laboratory Medicine, Microbiology, Molecular Biology)</li>
                    </ul>
                    <h4>Second Semester (Compulsory)</h4>
                    <ul>
                        <li>Biostatistics</li>
                        <li>Foundational Pharmacological Principles</li>
                        <li>Fundamentals of Clinical Medicine 3 (Dermatology, Endocrinology, Physical Training Sciences and Methodology, Gastroenterology)</li>
                        <li>Fundamentals of Clinical Medicine 3 (Clerkship) (Dermatology, Endocrinology, Gastroenterology)</li>
                    </ul>

                    <h3>Fourth Year</h3>
                    <h4>Optional Courses (Clerkship)</h4>
                    <ul>
                        <li>Clinical and Surgical Pathology (Pathology)</li>
                        <li>Clinical Imaging (Radiology)</li>
                        <li>Clinical Oncology, Emato-Oncology and Radiotherapy (Blood Diseases, Oncology, Pathology, Pharmacology, Radiology)</li>
                        <li>Fundamental Pharmacology and Therapeutics (Pharmacology)</li>
                        <li>Head and Neck (Odontostomatological Diseases, Ophthalmology, Otorhinolaryngology)</li>
                        <li>Infectious Diseases (Infectious Diseases, Pharmacology)</li>
                        <li>Medical Psychology (Clinical Psychology, General Psychology, Psychobiology and Physiologic Psychology)</li>
                        <li>Orthopedics, Traumatology and Rehabilitation (Orthopedics, Rehabilitation Medicine)</li>
                        <li>Translational Medicine and Biotechnologies 2 (Clinical Biochemistry, Clinical Pathology, Laboratory Medicine, Microbiology)</li>
                    </ul>
                    <h4>First Semester (Compulsory)</h4>
                    <ul>
                        <li>Clinical Oncology, Emato-Oncology and Radiotherapy (Blood Diseases, Medical Oncology, Pathology, Pharmacology, Radiology and Radiotherapy)</li>
                        <li>Clinical Oncology, Emato-Oncology and Radiotherapy (Clerkship) (Blood Diseases, Medical Oncology)</li>
                        <li>Head and Neck (Anatomy, Human Physiology, Odontostomatological Diseases, Ophthalmology, Otorhinolaryngology)</li>
                        <li>Head and Neck (Clerkship) (Ophthalmology, Otorhinolaryngology)</li>
                        <li>Infectious Diseases (Infectious Diseases, Pharmacology)</li>
                        <li>Infectious Diseases (Clerkship) (Infectious Diseases)</li>
                        <li>Orthopedics, Traumatology and Rehabilitation (Orthopedics, Rehabilitation Medicine)</li>
                        <li>Orthopedics, Traumatology and Rehabilitation (Clerkship) (Orthopedics)</li>
                    </ul>
                    <h4>Second Semester (Compulsory)</h4>
                    <ul>
                        <li>Clinical and Surgical Pathology (Pathology)</li>
                        <li>Clinical and Surgical Pathology (Clerkship) (Pathology)</li>
                        <li>Clinical Imaging (Radiology)</li>
                        <li>Clinical Imaging (Clerkship) (Radiology)</li>
                        <li>Fundamental Pharmacology and Therapeutics (Pharmacology)</li>
                        <li>Medical Psychology (Clinical Psychology, General Psychology, Psychobiology and Physiologic Psychology, Social Psychology)</li>
                        <li>Translational Medicine and Biotechnologies 2 (Clinical Biochemistry, Clinical Pathology, Laboratory Medicine, Microbiology)</li>
                    </ul>

                    <h3>Fifth Year</h3>
                    <h4>Optional Courses (Clerkship)</h4>
                    <ul>
                        <li>Fundamentals of Surgery (Cardiac Surgery, General Surgery, Maxillofacial Surgery, Neurosurgery, Plastic Surgery, Thoracic Surgery, Urology, Vascular Surgery)</li>
                        <li>Gynecology and Reproductive Medicine (Obstetrics, Gynecology, Urology)</li>
                        <li>Medical Science and Clinical Investigation (Blood Diseases, Cardiovascular Diseases, Endocrinology, Gastroenterology, Nephrology, Physical Training Sciences, Respiratory Diseases, Rheumatology)</li>
                        <li>Neurological and Behavioural Disorders (Mental Health, Neurology, Neuroradiology, Neurosurgery, Pharmacology, Rehabilitation Medicine)</li>
                        <li>Pediatrics and Child Care (Child Neuropsychiatry, Pediatrics)</li>
                        <li>Public, Global Health, Occupational Medicine, and Forensic Sciences (Forensic Medicine, General and Applied Hygiene, Medical Statistics, Occupational Medicine)</li>
                    </ul>
                    <h4>First Semester (Compulsory)</h4>
                    <ul>
                        <li>Fundamentals of Surgery (Cardiac Surgery, General Surgery, Maxillofacial Surgery, Neurosurgery, Plastic Surgery, Thoracic Surgery, Vascular Surgery)</li>
                        <li>Fundamentals of Surgery (Clerkship) (General Surgery)</li>
                        <li>Medical Sciences and Clinical Investigation (Internal Medicine, Rheumatology)</li>
                        <li>Medical Sciences and Clinical Investigation (Clerkship) (Internal Medicine, Rheumatology)</li>
                        <li>Neurobiology, Human Behaviour and Clinical Neuroscience (Clerkship) (Mental Health, Neurology)</li>
                        <li>Neurological and Behavioural Disorders (Mental Health, Neurology, Neuroradiology, Pharmacology, Rehabilitation Medicine)</li>
                    </ul>
                    <h4>Second Semester (Compulsory)</h4>
                    <ul>
                        <li>Evaluation Internship - Medical Sciences</li>
                        <li>Evaluation Internship - Surgical Sciences</li>
                        <li>Gynecology and Reproductive Medicine (Obstetrics, Gynecology, Urology)</li>
                        <li>Gynecology and Reproductive Medicine (Clerkship) (Obstetrics, Gynecology, Urology)</li>
                        <li>Pediatrics and Child Care (Child Neuropsychiatry, Pediatrics)</li>
                        <li>Pediatrics and Child Care (Clerkship) (Pediatrics)</li>
                        <li>Public, Global Health, Occupational Medicine, and Forensic Sciences (Business Economics, Forensic Medicine, General and Applied Hygiene, Medical Statistics, Occupational Medicine)</li>
                    </ul>

                    <h3>Sixth Year</h3>
                    <ul>
                        <li>Evaluation Internship - General Practice</li>
                        <li>Emergencies</li>
                        <li>Anesthesiology</li>
                        <li>General Surgery</li>
                        <li>Internal Medicine</li>
                        <li>Emergencies (Clerkship)</li>
                        <li>Anesthesiology</li>
                        <li>General Surgery</li>
                        <li>Internal Medicine</li>
                        <li>Multidisciplinary Clinical Management</li>
                        <li>Cardiovascular Diseases</li>
                        <li>Endocrinology</li>
                        <li>General Surgery</li>
                        <li>History of Medicine</li>
                        <li>Medical Informatics</li>
                        <li>Medical Oncology</li>
                        <li>Nephrology</li>
                        <li>Radiology and Radiotherapy</li>
                        <li>Respiratory Diseases</li>
                        <li>Multidisciplinary Clinical Management (Clerkship)</li>
                        <li>Gastroenterology</li>
                        <li>Internal Medicine</li>
                        <li><strong>Final Examination</strong></li>
                    </ul>
                </section>

                <section className="tuition-fees">
                    <h2>Tuition Fees and Scholarships</h2>
                    <p>Tuition fees at the University of Milan are based on the student's financial situation, assessed through the <strong>ISEE (Equivalent Economic Status Indicator)</strong>. They range from <strong>€156 to around €4,000 per year</strong>, depending on income.</p>
                    <p>Scholarships are available through <strong>EDiSU</strong>, the regional organization that provides financial aid based on academic merit and financial need. Some students may also qualify for housing benefits, meal plans, and tuition fee reductions.</p>
                    <p><strong>EDISU Scholarship:</strong> <a href="https://www.edisu.pv.it/uploads/Call%20for%20Scholarship%20applications%20for%20the%202024-2025%20per%20pubblicazione.pdf">EDISU Scholarship Link</a></p>
                </section>

                <section className="exams">
                    <h2>How Exams Work</h2>
                    <p>Exams at the University of Milan's medical school are typically a mix of:</p>
                    <ul>
                        <li><strong>Oral exams:</strong> Professors test students on their understanding of key concepts in a face-to-face discussion.</li>
                        <li><strong>Written exams:</strong> These may include multiple-choice questions, short-answer questions, or problem-solving exercises.</li>
                        <li><strong>Practical exams:</strong> In later years, students are assessed on their clinical skills, patient interactions, and problem-solving abilities in real hospital settings.</li>
                    </ul>
                    <p>Exams are usually held at the end of each semester. The grading scale is from <strong>0 to 30</strong>, with <strong>18 being the minimum passing score</strong> and <strong>30 cum laude</strong> being the highest.</p>
                </section>

                <section className="city-info">
                    <h2>Life of an International Student in Milan</h2>
                    <p>Milan is a fantastic city for international students, offering a blend of history, culture, and modern city life. The University of Milan has a diverse student body, with students from all over the world. English-speaking programs make integration easier, and various student associations help newcomers settle in.</p>
                    <p>Students can enjoy:</p>
                    <ul>
                        <li>Affordable student housing through <strong>EDiSU</strong> or private rentals.</li>
                        <li>Discounted public transport for students.</li>
                        <li>A vibrant social life with events, networking opportunities, and cultural activities.</li>
                    </ul>
                </section>

                <section className="milan-info">
                    <h2>Milan as a City</h2>
                    <p>Milan is not just Italy's financial capital; it is also a hub of fashion, design, and culture. As a student, you'll be living in a city that offers:</p>
                    <ul>
                        <li><strong>World-class museums</strong> like Leonardo da Vinci's Last Supper.</li>
                        <li><strong>Lively nightlife and restaurants</strong> offering authentic Italian cuisine.</li>
                        <li><strong>Great public transport</strong> making it easy to explore Italy.</li>
                        <li><strong>Proximity to top hospitals and research centers</strong>, enhancing clinical learning opportunities.</li>
                    </ul>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>The University of Milan (Statale) provides an excellent medical education at an affordable cost, with strong academic rankings and access to world-class hospitals. Milan offers international students a rich cultural experience, making it an ideal destination for those looking to pursue a medical degree in one of Europe's most dynamic cities.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage11;